import { render, staticRenderFns } from "./casinoBetting.vue?vue&type=template&id=61f94fae"
import script from "./casinoBetting.vue?vue&type=script&lang=js"
export * from "./casinoBetting.vue?vue&type=script&lang=js"
import style0 from "./casinoBetting.vue?vue&type=style&index=0&id=61f94fae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports